export const inputStepper = 0.0001;

export const amountPrecision =
	process.env.REACT_APP_MONETERY_DECIMAL_PRECISION ?? 4;
